import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { AuthProvider } from "react-oidc-context";

const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI,
  post_logout_redirect_uri: window.location.origin,
  response_type: "code",
  scope: "email openid phone",
};

const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN || "https://ap-south-11j2oy3yf8.auth.ap-south-1.amazoncognito.com";

console.log("Cognito Domain Configured:", cognitoDomain);
console.log("Environment Var:", process.env.REACT_APP_COGNITO_DOMAIN);

if (cognitoDomain) {
  const domain = cognitoDomain.replace(/\/$/, ""); // Remove trailing slash if present
  cognitoAuthConfig.metadata = {
    issuer: process.env.REACT_APP_COGNITO_AUTHORITY,
    authorization_endpoint: `${domain}/oauth2/authorize`,
    token_endpoint: `${domain}/oauth2/token`,
    userinfo_endpoint: `${domain}/oauth2/userInfo`,
    end_session_endpoint: `${domain}/logout`,
  };
  console.log("Forcing OIDC Metadata:", cognitoAuthConfig.metadata);
}

const root = ReactDOM.createRoot(document.getElementById("root"));

// wrap the application with AuthProvider
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
